import type { StyleSpecification } from 'maplibre-gl'

export function getMapyMapStyle(): StyleSpecification {
  const apiKey = import.meta.env.VITE_MAPY_API_KEY
  if (!apiKey) {
    throw new Error('VITE_MAPY_API_KEY is not configured')
  }

  return {
    version: 8,
    sources: {
      'mapy-basic': {
        type: 'raster',
        tiles: [
          `https://api.mapy.com/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${apiKey}`,
        ],
        tileSize: 256,
        attribution:
          '<a href="https://api.mapy.com/copyright" target="_blank" rel="noreferrer">© Seznam.cz a.s. a další</a>',
      },
    },
    layers: [
      {
        id: 'mapy-basic-tiles',
        type: 'raster',
        source: 'mapy-basic',
      },
    ],
  }
}
